import { VISIBLE_IMAGES_LIMIT_3, VISIBLE_IMAGES_LIMIT_4 } from 'common/config';

export const getVisibleImages = <T extends { image?: string }>(
  array: T[],
): { visibleImages: string[]; hiddenImagesCount: number } => {
  const images = array.map((item) => item.image).filter((item) => item !== undefined);
  const visibleImages = images.length > VISIBLE_IMAGES_LIMIT_4 ? images.slice(0, VISIBLE_IMAGES_LIMIT_3) : images;
  const hiddenImagesCount = images.length - visibleImages.length;

  return { visibleImages, hiddenImagesCount };
};
